var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "4 0 67 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_21)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 67,
    height: 55,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_21",
    x: 0,
    y: 0,
    width: 75,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_21"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_21",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_21",
    transform: "translate(-0.00165837) scale(0.00456053 0.00555556)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_21",
    width: 220,
    height: 180,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.b3f9dda6b3e9a4f742686e0e7cf1f36f.svg";
export { ForwardRef as ReactComponent };